/*
 * Copyright (c) 2019 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { InjectionToken } from '@angular/core';

export class AuthOptions {
  storage: 'local-storage' | 'cookie' = 'local-storage';
}

export const AUTH_OPTIONS = new InjectionToken<string>('AUTH_OPTIONS');

export const localStorageTokenName = 'authenticationToken';
export const cookieTokenName = 'access_token';
